import React from 'react';

export const STATUS_RECEBIMENTO = {
  PENDENTE: { label: 'Pendente', className: 'tb-tag tb-tag-warn', icon: 'pi pi-clock' },
  CONFERIDO: { label: 'Conferido', className: 'tb-tag tb-tag-ok', icon: 'pi pi-check' },
  ATUALIZADO: { label: 'Já atualizado', className: 'tb-tag tb-tag-info', icon: 'pi pi-verified' },
  IGNORADO: { label: 'Ignorado', className: 'tb-tag tb-tag-muted', icon: 'pi pi-ban' },
};

export function StatusTag({ status }) {
  const s = STATUS_RECEBIMENTO[status] || { label: status, className: 'tb-tag', icon: '' };
  return <span className={s.className}><i className={s.icon} /> {s.label}</span>;
}

export function SituacaoProdutoTag({ produto }) {
  if (!produto) return null;
  if (produto.atualizado) return <span className="tb-tag tb-tag-ok"><i className="pi pi-check" /> Conferido</span>;
  if (produto.conferido) return <span className="tb-tag tb-tag-danger"><i className="pi pi-exclamation-triangle" /> Conferência vencida</span>;
  return <span className="tb-tag tb-tag-warn"><i className="pi pi-clock" /> Não conferido</span>;
}

export const formatarCnpj = v => {
  const d = String(v || '').replace(/\D/g, '');
  if (d.length !== 14) return v || '';
  return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
};

export const formatarNcm = v => {
  const d = String(v || '').replace(/\D/g, '');
  if (d.length !== 8) return v || '';
  return `${d.substring(0, 4)}.${d.substring(4, 6)}.${d.substring(6, 8)}`;
};

export const hojeIso = (deltaDias = 0) => {
  const d = new Date();
  d.setDate(d.getDate() + deltaDias);
  const p = n => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

export const dateToIso = d => {
  if (!d) return undefined;
  const p = n => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

/** Campos fiscais vazios para um produto novo. */
export const TRIBUTOS_VAZIO = {
  id: null,
  codigoEan: '',
  descricao: '',
  ncm: '',
  cest: '',
  origemMercadoria: 0,
  cfopVenda: '',
  cstVenda: '',
  csosnVenda: '',
  icmsModalidadeBc: 3,
  icmsAliquota: 0,
  icmsPRedBc: 0,
  icmsAliquotaFcp: 0,
  icmsModalidadeBcSt: 0,
  icmsAliquotaSt: 0,
  icmsPRedBcSt: 0,
  mva: 0,
  mvaSt: 0,
  pisCofinsEntradaCst: '',
  pisEntradaAliquota: 0,
  cofinsEntradaAliquota: 0,
  pisCofinsSaidaCst: '',
  pisSaidaAliquota: 0,
  cofinsSaidaAliquota: 0,
  naturezaReceita: '',
  cClassTribIBSCBS: '',
  cClassTribIBSCBSRegular: '',
  cClassTribIS: '',
  codigoAliquotasCredPresIBSCBS: '',
  aliquotaAdRemIBS: 0,
  aliquotaAdRemCBS: 0,
  aliquotaAdValoremIBSUF: 0,
  aliquotaAdValoremIBSMun: 0,
  aliquotaAdValoremCBS: 0,
  pDifIBSUF: 0,
  pDifIBSMun: 0,
  pDifCBS: 0,
  cnpjCliente: '',
  registroProduto: null,
  conferido: false,
  atualizado: false,
  dataCadastro: null,
  dataConferencia: null,
};

/** Mescla o retorno da API com os valores padrão (evita null em inputs controlados). */
/** Tributação usada como modelo/sugestão: descarta o cClassTrib regular quando é igual ao cClassTrib IBS/CBS. */
export function limparClassTribRegularIgual(t) {
  if (!t) return t;
  const a = String(t.cClassTribIBSCBS || '').trim();
  const b = String(t.cClassTribIBSCBSRegular || '').trim();
  return a && a === b ? { ...t, cClassTribIBSCBSRegular: '' } : t;
}

export function normalizarTributos(dados) {
  const base = { ...TRIBUTOS_VAZIO };
  if (!dados) return base;
  Object.keys(dados).forEach(k => {
    if (dados[k] !== null && dados[k] !== undefined) base[k] = dados[k];
  });
  return base;
}
